"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FeaturedSidebar = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _UserAvatar = _interopRequireDefault(require("../../User/UserAvatar"));

var _publish = _interopRequireDefault(require("../../../components/tracker/publish"));

var _common = require("@insided/shared/utils/common");

var _dateRelative = _interopRequireDefault(require("../../../libs/translationsUtils/dateRelative"));

var _classnames = _interopRequireDefault(require("classnames"));

var eventTracker = function eventTracker() {
  _publish.default.trackEvent('userevent', {
    type: 'Sidebar Widget Clicked',
    widget: 'notification',
    click_source: (0, _common.getCurrentPage)()
  });
};

var FeaturedSidebar = function FeaturedSidebar(_ref) {
  var data = _ref.data;
  var topic = data[0];
  var author = topic.author;
  return (0, _preact.h)("a", {
    className: (0, _classnames.default)('box', 'sidebar-notification', 'notification'),
    onClick: eventTracker,
    href: (0, _absoluteUrlRuntime.resolveUrl)(topic.url)
  }, (0, _preact.h)("div", {
    className: "box__content box__pad"
  }, (0, _preact.h)("p", {
    className: "notification-title"
  }, (0, _preact.h)("span", {
    className: "notification-link"
  }, topic.title)), (0, _preact.h)("span", {
    className: "thread-meta-item"
  }, (0, _preact.h)(_UserAvatar.default, {
    user: author,
    extraClass: "avatar avatar--S",
    showRank: true
  }), (0, _preact.h)("span", {
    className: "notification-link"
  }, (0, _preact.h)("span", {
    className: "thread-meta-item__date"
  }, (0, _preact.h)(_dateRelative.default, {
    dateTime: new Date(topic.publishedAt).getTime()
  }))))));
};

exports.FeaturedSidebar = FeaturedSidebar;

var FeaturedSidebarWithHelp = function FeaturedSidebarWithHelp() {
  return (0, _preact.h)("div", {
    className: "widget-configuration_info-box"
  }, (0, _preact.h)("strong", null, "\u2728 How to highlight an announcement"), (0, _preact.h)("p", null, "Open a topic in control and add the moderator tag \u2018featured_side\u2019 to make it an announcement card."), (0, _preact.h)("p", null, "\u26A0\uFE0F This topic might be visible on other pages in your community, if announcement card widget is enable in General sidebar or Topic sidebar in Sidebar."), (0, _preact.h)("p", null, "\u26A0\uFE0F Only one topic can be featured"));
};

var _default = FeaturedSidebarWithHelp;
exports.default = _default;